export default {
  getCurrentSemesterUserForAUser: '/semesterUser/getCurrentSemesterUserForAUser',
  getSubjectsOfASemesterUser: '/semesterUser/getSubjectsOfASemesterUser',
  getSemesterUser: '/semesterUser/getSemesterUser',
  getSemesterUsersForAUser: '/semesterUser/getSemesterUsersForAUser',
  getStudentsByInstituteAndDepartmentAndUid: '/semesterUser/getStudentsByInstituteAndDepartmentAndUid',
  updateSubjects: '/semesterUser/updateSubjects',
  getSemesterUserForACourseYear: '/semesterUser/getSemesterUserForACourseYear'
}
